const common = {
  error: {
    unauthorized: '不正アクセス',
    required: '必須'
  },
  common: {
    mandatory: '必須項目',
    downloadCsv: 'CSV のダウンロード'
  },
  utils: {
    dashboard: 'ダッシュボード',
    systems: 'システム',
    account: 'アカウント',
    services: 'サービス',
    dataPrivacy: 'データとプライバシー',
    support: 'サポート',
    admin: '管理者',
    defaultMessage: 'ファイルをダウンロードするには、ブラウザのポップアップブロックを無効にしてください',
    signInMessage: '続行する前にサインインまたはサインアップする必要があります',
    commonApiMessage: 'リクエストを処理できませんでした',
    adminNew: '管理者(新規)'
  },
  message: {
    yelpWaitMessage: 'Yelpの更新を待つ',
    googleWaitMessage: 'GoogleプレイスIDの更新を待つ',
    successMessageUpload: 'ファイルは正常にアップロードされました。',
    failureMessageUpload: '何らかの問題が発生しました。やり直してください',
    serviceAreasCreateSuccess: 'サービスエリアは正常に作成されました',
    serviceAreasUpdateSuccess: 'サービスエリアは正常に更新されました',
    serviceAreasDeleteSuccess: 'サービスエリアは正常に削除されました',
    hardware_product: 'ハードウェア製品',
    rowsFailed: '%{failedCount} / %{totalCount} 行が失敗しました',
    accessRequestSuccess: 'アクセスが正常に要求されました',
    accessToPageDenied: 'このページへのアクセスは許可されていません!'
  },
  buttons: {
    cancel: 'キャンセル',
    edit: '編集',
    update: '更新',
    updateAccount: 'アカウント更新',
    submit: '送信',
    submitUpperCase: '送信',
    back: '戻る',
    save: '保存',
    show: '表示',
    add: '追加',
    downloadSampleFile: 'サンプルファイルのダウンロード',
    proceed: '進む',
    close: '閉じる',
    privacyBanner: 'プライバシー｜私の個人情報を販売または共有したりしないでください。'
  }
};

export default common;
